import { useState } from 'react';
import { DatePicker, Button, Space, Card, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import useApis from '../apis/useApis';
import appConstant from '../json/appConstant.json';
import moment from 'moment';

const { RangePicker } = DatePicker;

const FilterComponent = ({ onSearch, isDarkMode, onDataReceived }) => {
  const [dates, setDates] = useState([]);
  const [loading, setLoading] = useState(false);
  const { jsonApi } = useApis();

  // Function to disable future dates
  const disabledDate = (current) => {
    // Can not select future dates
    return current && current > moment().endOf('day');
  };

  const handleSearch = async () => {
    const [startDate, endDate] = dates || [];
    if (!startDate || !endDate) {
      message.warning('Please select both start and end dates');
      return;
    }

    setLoading(true);
    try {
      const formattedStartDate = startDate.format('YYYY-MM-DD');
      const formattedEndDate = endDate.format('YYYY-MM-DD');

      // Update parent component with date filter state
      onSearch?.({
        startDate: formattedStartDate,
        endDate: formattedEndDate
      });

      // Fetch filtered data to check if it's empty
      const response = await jsonApi(
        appConstant.User,
        {
          startDate: formattedStartDate,
          endDate: formattedEndDate
        },
        null,
        null
      );

      if (response?.data?.code === 200 && response?.data?.status === "success") {
        if (response.data.data.users.length === 0) {
          message.error('No Data Found');
        } else {
          message.success('Data Filtered Successfully');
        }
      }
    } catch (error) {
      console.error('Error in date filter:', error);
      message.error('Failed to apply date filter');
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setDates(null);
    onSearch?.({ startDate: null, endDate: null });

    onDataReceived?.({ data: [], total: 0 });

    // Fetch all user data when the filter is cleared
    const fetchAllData = async () => {
      const response = await jsonApi(appConstant.User, {}, null, null);
      if (response?.data?.code === 200 && response?.data?.status === "success") {
        const mappedData = {
          data: response.data.data.users.map((user) => ({
            key: user.id,
            id: user.id,
            name: user.name,
            email: user.email,
            phone: user.phone,
            department_id: user.department_id,
            department_name: user.department_name,
            createdAt: user.createdAt,
          })),
          total: response.data.data.totalUsers
        };
        onDataReceived?.(mappedData);
      }
    };

    fetchAllData();
  };
  

  const handleDateChange = (values) => {
    setDates(values);
    if (!values) {
      handleClear();
    }
  };

  return (
    <Card
      style={{
        marginBottom: '20px',
        background: isDarkMode ? '#1f1f1f' : '#ffffff',
        borderColor: isDarkMode ? '#303030' : '#f0f0f0',
      }}
    >
      <Space size="middle">
        <RangePicker
          style={{ width: '300px' }}
          onChange={handleDateChange}
          format="YYYY-MM-DD"
          placeholder={['Start Date', 'End Date']}
          value={dates}
          allowClear={true}
          disabledDate={disabledDate} 
        />
        <Button
          type="primary"
          icon={<SearchOutlined />}
          onClick={handleSearch}
          loading={loading}
        >
          Search
        </Button>
      </Space>
    </Card>
  );
};

export default FilterComponent;
